import React from 'react';
import clsx from 'clsx';
import Typography from '~/shared/components/Typography/Typography';
import styles from './BonusPointsCard.module.scss';
import { useTranslation } from '~/shared/utils/translation';
import Watermark from '~/shared/components/Watermarks/Watermark';

import SymbolWindowIcon from '~/icons/symbol-window.svg';

interface BonusPointsCardProps {
    amount?: number;
    currency?: string;
    expiryDate?: string;
    alternateText?: string;
    className?: string;
    variant?: 'regular' | 'small' | 'empty';
}

const BonusPointsCard: React.FC<BonusPointsCardProps> = ({
    amount = 0,
    currency = 'kr',
    expiryDate,
    alternateText,
    className,
    variant = 'regular',
}) => {
    const { translate } = useTranslation();

    // Determine what text to display
    const displayText =
        variant === 'empty'
            ? translate('loyalty.bonusPoints.card.advice')
            : alternateText ||
              (expiryDate
                  ? translate('loyalty.bonusPoints.card.expiryInfo', {
                        date: String(expiryDate),
                    })
                  : '');

    return (
        <div className={clsx(styles.card, styles[`card--${variant}`], className)}>
            <Watermark type="Logo" className={styles.watermark} aria-hidden />
            <div className={styles.amount}>
                <Typography variant="title-M" as="span" className={styles.value}>
                    {amount}
                </Typography>
                <Typography variant="paragraph-M" as="span" className={styles.currency}>
                    {currency}
                </Typography>
            </div>
            {displayText && (
                <Typography variant="paragraph-XS" as="span" className={styles.footNote}>
                    {displayText}
                </Typography>
            )}
            <div className={styles.logoIcon} aria-hidden="true">
                <SymbolWindowIcon />
            </div>
        </div>
    );
};

export default BonusPointsCard;
